import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../types';
import { ModalEntry } from '../slices/modalSlice';

// Base selector to get all modals
export const selectModals = (state: RootState): ModalEntry[] => state.modals;

// Select the current (top) modal
export const selectCurrentModal = createSelector(
  [selectModals],
  modals => modals[modals.length - 1] || null,
);

// Select modal by index
export const selectModalByIndex = (index: number) =>
  createSelector([selectModals], modals => modals[index] || null);

// Check if any modals are open
export const selectIsModalOpen = createSelector([selectModals], modals => modals.length > 0);

// Count of open modals
export const selectModalCount = createSelector([selectModals], modals => modals.length);

// Check if a specific modal type is open
export const selectIsModalTypeOpen = (modalType: string) =>
  createSelector([selectModals], modals => modals.some(modal => modal.modalType === modalType));

// Get all modals of a specific type
export const selectModalsByType = (modalType: string) =>
  createSelector([selectModals], modals => modals.filter(modal => modal.modalType === modalType));

// Check if modal is at the top of the stack
export const selectIsModalOnTop = (modalId: string) =>
  createSelector([selectModals], modals => {
    const topModal = modals[modals.length - 1];
    return topModal?.id === modalId;
  });

// Get modal stack depth
export const selectModalStackDepth = createSelector([selectModals], modals => modals.length);
